module.exports = __webpack_public_path__ + "static/media/reward_points.bd0cbe90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/reward_points.svg
// module id = 2717
// module chunks = 0